import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';
import { shopPods } from 'apps/cart/paths';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class FreeShippingCartUpsell extends React.Component {
  render() {
    const { freeShippingAmount } = this.props;
    if (!freeShippingAmount) return null;

    return (
      <div className="CartUpsellBanner">
        <h4 className="CartUpsellBanner__heading heading--medium">
          <TranslatedMessage id={'cart.upsell_banner.free_shipping'} />
        </h4>
        <p className="CartUpsellBanner__copy text--body">
          <TranslatedMessage
            id={'cart.upsell_banner.orders_over_free_shipping'}
            values={{
              price: <PriceSpan cents={this.props.freeShippingAmount} />,
            }}
          />
        </p>
        <a href={shopPods()} className="CartUpsellBanner__link text--button">
          <TranslatedMessage id={'shop_pods_now'} />
        </a>
      </div>
    );
  }
}
